module.exports = __webpack_public_path__ + "img/lung-cancer-leaflet.635f7220.jpg";